export const DEFAULT_LANG = 'pt';
export const ALL_LANGS = ['pt', 'en'] as const;

export const DEFAULT_SITE_BASE_URL = 'https://www.lightlab.pt';

export const SITE_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000'
    : process.env.GATSBY_SITE_BASE_URL || DEFAULT_SITE_BASE_URL;
